import { render, staticRenderFns } from "./donation-news-form.vue?vue&type=template&id=429c3a62&"
import script from "./donation-news-form.vue?vue&type=script&lang=js&"
export * from "./donation-news-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports